module.exports = __webpack_public_path__ + "img/unlimited-coffee-tea.674fe3b2.svg";